import React from "react";
import { Button, useTheme } from "@mui/material";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const CustomButton = ({
  children,
  backgroundColor = "#000",
  backgroundImage = "",
  hoverColor = "#000",
  borderColor = "#fff",
  textColor = "#fff",
  border = false,
  icon: Icon,
  width = "auto",
  fontWeight = "500",
  ...props
}) => {
  const theme = useTheme();
  const { i18n } = useTranslation();
  const locale = i18n.language;

  return (
    <Button
      {...props}
      sx={{
        backgroundColor,
        color: textColor,
        padding: "16px 24px",
        borderRadius: "12px",
        border: border ? "1px solid #D6D8DB" : "none",
        display: "flex",
        alignItems: "center",
        flexDirection: locale === "ar" ? "row" : "",
        fontWeight: 600,
        textTransform: "capitalize",
        backgroundImage,
        width,
        height: "52px",
        fontSize: { xs: "12px", md: "18px" },
        transition: "transform 0.4s cubic-bezier(0.4, 0, 0.2, 1), background-color 0.4s cubic-bezier(0.4, 0, 0.2, 1)", // Adjusted for smoothness
        "&:hover": {
          transform: "scale(1.05)",
        },
        [theme.breakpoints.up("md")]: {
          padding: "16px 24px",
        },
        [theme.breakpoints.up("xs")]: {
          padding: "7px 10px",
        },
      }}
    >
      {Icon && (
        <Icon
          style={{
            marginRight: locale === "en" ? 8 : 0,
            marginLeft: locale === "en" ? 0 : 8,
          }}
        />
      )}
      {children}
    </Button>
  );
};

CustomButton.propTypes = {
  children: PropTypes.node.isRequired,
  backgroundColor: PropTypes.string,
  hoverColor: PropTypes.string,
  borderColor: PropTypes.string,
  textColor: PropTypes.string,
  border: PropTypes.bool,
  icon: PropTypes.elementType,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fontWeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default CustomButton;
